import {
  ApolloClientInterface,
  EventBusInterface,
  InfoInterface,
  GlobalInterface,
  ConsultationContextInterface,
  AbstractModelProviderInterface,
  MainInterface,
  AdminPortalPageInterface,
  AdminPortalPageNavigationItemInterface,
  ScheduleCheckInPluginInterface,
  ConsultationCheckInPluginInterface,
  AppointmentInvitesPluginInterface,
  AppointmentInvitesSummaryPluginInterface,
  AttachmentsPluginInterface,
  AttachmentsSummaryPluginInterface,
  BookingReasonSummaryPluginInterface,
  BookingReasonPluginInterface,
  CallStatusReducerModelProviderInterface,
  CallPluginInterface,
  CarePlanSummaryPluginInterface,
  CarePlanSectionPluginInterface,
  AbstractCompleteConsultationExtensionInterface,
  CompleteConsultationModelInterface,
  CompleteDialogPluginInterface,
  EditedConsultationWarningModelProviderInterface,
  PostConsultationFormModalInterface,
  CallActiveModalPluginInterface,
  ConsultationActionsPluginInterface,
  MarkAsSensitiveModelInterface,
  MarkAsSensitivePluginInterface,
  UsEhrNotesCompletionModelInterface,
  InsuranceClaimCheckModelInterface,
  InsuranceClaimCheckPluginInterface,
  CarePlansCompletionModelInterface,
  ConsultationLitePageInterface,
  ExternalTabsWarningBannerPluginInterface,
  IncompleteConsultationWarningModalPluginInterface,
  ConsultationProfilePluginInterface,
  AllConsultationsPageInterface,
  AllConsultationsPageNavigationItemInterface,
  PastConsultationSummaryPluginInterface,
  CurrentConsultationSummaryPluginInterface,
  DocumentRepositoryPluginInterface,
  EhrCheckInUsPluginInterface,
  USEhrSummaryPluginInterface,
  ExperimentsPageInterface,
  GpDetailsPluginInterface,
  HeaderInterface,
  LayoutInterface,
  LinksAndResourcesPluginInterface,
  NavigationInterface,
  NoteAssistantSummaryPluginInterface,
  CallRecordingPluginInterface,
  PatientAlertsPluginInterface,
  PatientDetailsPluginInterface,
  PatientRecordDeepLinkPluginInterface,
  TimelineConsultationEventPluginInterface,
  PatientTimelinePluginInterface,
  PreconsultationSummaryPluginInterface,
  PreConsultationFlowPluginInterface,
  ReleaseNotesPluginInterface,
  SchedulePageInterface,
  SchedulePageNavigationItemInterface,
  ConsultationScheduleItemPluginInterface,
  SectionGroupPluginInterface,
  RoutesInterface,
  TelusAsyncChatPageInterface,
  TelusAsyncChatPageNavigationItemInterface,
  USEhrDeepLinkPluginInterface
} from '../../modules/generated/types'

type Modules = {
  ApolloClient: ApolloClientInterface
  EventBus: EventBusInterface
  Info: InfoInterface
  Global: GlobalInterface
  ConsultationContext: ConsultationContextInterface
  AbstractModelProvider: AbstractModelProviderInterface
  Main: MainInterface
  AdminPortalPage: AdminPortalPageInterface
  AdminPortalPageNavigationItem: AdminPortalPageNavigationItemInterface
  ScheduleCheckInPlugin: ScheduleCheckInPluginInterface
  ConsultationCheckInPlugin: ConsultationCheckInPluginInterface
  AppointmentInvitesPlugin: AppointmentInvitesPluginInterface
  AppointmentInvitesSummaryPlugin: AppointmentInvitesSummaryPluginInterface
  AttachmentsPlugin: AttachmentsPluginInterface
  AttachmentsSummaryPlugin: AttachmentsSummaryPluginInterface
  BookingReasonSummaryPlugin: BookingReasonSummaryPluginInterface
  BookingReasonPlugin: BookingReasonPluginInterface
  CallStatusReducerModelProvider: CallStatusReducerModelProviderInterface
  CallPlugin: CallPluginInterface
  CarePlanSummaryPlugin: CarePlanSummaryPluginInterface
  CarePlanSectionPlugin: CarePlanSectionPluginInterface
  AbstractCompleteConsultationExtension: AbstractCompleteConsultationExtensionInterface
  CompleteConsultationModel: CompleteConsultationModelInterface
  CompleteDialogPlugin: CompleteDialogPluginInterface
  EditedConsultationWarningModelProvider: EditedConsultationWarningModelProviderInterface
  PostConsultationFormModal: PostConsultationFormModalInterface
  CallActiveModalPlugin: CallActiveModalPluginInterface
  ConsultationActionsPlugin: ConsultationActionsPluginInterface
  MarkAsSensitiveModel: MarkAsSensitiveModelInterface
  MarkAsSensitivePlugin: MarkAsSensitivePluginInterface
  UsEhrNotesCompletionModel: UsEhrNotesCompletionModelInterface
  InsuranceClaimCheckModel: InsuranceClaimCheckModelInterface
  InsuranceClaimCheckPlugin: InsuranceClaimCheckPluginInterface
  CarePlansCompletionModel: CarePlansCompletionModelInterface
  ConsultationLitePage: ConsultationLitePageInterface
  ExternalTabsWarningBannerPlugin: ExternalTabsWarningBannerPluginInterface
  IncompleteConsultationWarningModalPlugin: IncompleteConsultationWarningModalPluginInterface
  ConsultationProfilePlugin: ConsultationProfilePluginInterface
  AllConsultationsPage: AllConsultationsPageInterface
  AllConsultationsPageNavigationItem: AllConsultationsPageNavigationItemInterface
  PastConsultationSummaryPlugin: PastConsultationSummaryPluginInterface
  CurrentConsultationSummaryPlugin: CurrentConsultationSummaryPluginInterface
  DocumentRepositoryPlugin: DocumentRepositoryPluginInterface
  EhrCheckInUsPlugin: EhrCheckInUsPluginInterface
  USEhrSummaryPlugin: USEhrSummaryPluginInterface
  ExperimentsPage: ExperimentsPageInterface
  GpDetailsPlugin: GpDetailsPluginInterface
  Header: HeaderInterface
  Layout: LayoutInterface
  LinksAndResourcesPlugin: LinksAndResourcesPluginInterface
  Navigation: NavigationInterface
  NoteAssistantSummaryPlugin: NoteAssistantSummaryPluginInterface
  CallRecordingPlugin: CallRecordingPluginInterface
  PatientAlertsPlugin: PatientAlertsPluginInterface
  PatientDetailsPlugin: PatientDetailsPluginInterface
  PatientRecordDeepLinkPlugin: PatientRecordDeepLinkPluginInterface
  TimelineConsultationEventPlugin: TimelineConsultationEventPluginInterface
  PatientTimelinePlugin: PatientTimelinePluginInterface
  PreconsultationSummaryPlugin: PreconsultationSummaryPluginInterface
  PreConsultationFlowPlugin: PreConsultationFlowPluginInterface
  ReleaseNotesPlugin: ReleaseNotesPluginInterface
  SchedulePage: SchedulePageInterface
  SchedulePageNavigationItem: SchedulePageNavigationItemInterface
  ConsultationScheduleItemPlugin: ConsultationScheduleItemPluginInterface
  SectionGroupPlugin: SectionGroupPluginInterface
  Routes: RoutesInterface
  TelusAsyncChatPage: TelusAsyncChatPageInterface
  TelusAsyncChatPageNavigationItem: TelusAsyncChatPageNavigationItemInterface
  USEhrDeepLinkPlugin: USEhrDeepLinkPluginInterface
}

type ModuleNames = keyof Modules

type ModuleReturnType<Name extends ModuleNames> = Parameters<Modules[Name]>[0]

type ProviderProps = {
  children: React.ReactNode
  value?: any
}

interface ModelProvider<T = any> {
  (): T
  Provider: (props: ProviderProps) => JSX.Element
}

type ModuleConfig<Name extends ModuleNames> = {
  module: Name
  options?: ModuleReturnType<Name>
  providers?: ModelProvider[]
  reactElement?: boolean
  reactComponent?: boolean
}

type ModuleConfigMap = { [Name in ModuleNames]: ModuleConfig<Name> }

type ModuleConfigUnion = ModuleConfigMap[keyof ModuleConfigMap]

export type Config = Record<string, ModuleConfigUnion>

// NOTE: this bit is dynamically generated (requires config keys -> module name):
type ConfigReferences = {
  global: ReturnType<GlobalInterface>,
  eventBus: ReturnType<EventBusInterface>,
  apolloClient: ReturnType<ApolloClientInterface>,
  consultationContext: ReturnType<ConsultationContextInterface>,
  main: ReturnType<MainInterface>,
  layout: ReturnType<LayoutInterface>,
  routes: ReturnType<RoutesInterface>,
  header: ReturnType<HeaderInterface>,
  headerScheduleItem: ReturnType<ConsultationScheduleItemPluginInterface>,
  navigation: ReturnType<NavigationInterface>,
  schedulePage: ReturnType<SchedulePageInterface>,
  consultationScheduleItem: ReturnType<ConsultationScheduleItemPluginInterface>,
  consultationScheduleItemAppointmentCheckIn: ReturnType<ScheduleCheckInPluginInterface>,
  schedulePageNavigationItem: ReturnType<SchedulePageNavigationItemInterface>,
  allConsultationsPage: ReturnType<AllConsultationsPageInterface>,
  experimentsPage: ReturnType<ExperimentsPageInterface>,
  allConsultationsPageNavigationItem: ReturnType<AllConsultationsPageNavigationItemInterface>,
  adminPortalPage: ReturnType<AdminPortalPageInterface>,
  adminPortalPageNavigationItem: ReturnType<AdminPortalPageNavigationItemInterface>,
  consultationPage: ReturnType<ConsultationLitePageInterface>,
  editedConsultationWarningModelProvider: ReturnType<EditedConsultationWarningModelProviderInterface>,
  callStatusReducerModelProvider: ReturnType<CallStatusReducerModelProviderInterface>,
  callActiveModalPlugin: ReturnType<CallActiveModalPluginInterface>,
  consultationActionsPlugin: ReturnType<ConsultationActionsPluginInterface>,
  call: ReturnType<CallPluginInterface>,
  consultationProfile: ReturnType<ConsultationProfilePluginInterface>,
  patientRecordDeepLink: ReturnType<PatientRecordDeepLinkPluginInterface>,
  consultationProfileAppointmentCheckIn: ReturnType<ConsultationCheckInPluginInterface>,
  incompleteConsultationWarningModal: ReturnType<IncompleteConsultationWarningModalPluginInterface>,
  externalTabsWarningModal: ReturnType<ExternalTabsWarningBannerPluginInterface>,
  preparationSectionGroup: ReturnType<SectionGroupPluginInterface>,
  bookingReason: ReturnType<BookingReasonPluginInterface>,
  patientTimelineConsultationEvent: ReturnType<TimelineConsultationEventPluginInterface>,
  patientTimeline: ReturnType<PatientTimelinePluginInterface>,
  patientDetails: ReturnType<PatientDetailsPluginInterface>,
  actionsSectionGroup: ReturnType<SectionGroupPluginInterface>,
  appointmentInvites: ReturnType<AppointmentInvitesPluginInterface>,
  currentConsultationSummary: ReturnType<CurrentConsultationSummaryPluginInterface>,
  pastConsultationSummary: ReturnType<PastConsultationSummaryPluginInterface>,
  appointmentInvitesSummary: ReturnType<AppointmentInvitesSummaryPluginInterface>,
  preconsultationSummary: ReturnType<PreconsultationSummaryPluginInterface>,
  bookingReasonSummary: ReturnType<BookingReasonSummaryPluginInterface>,
  attachmentsSummary: ReturnType<AttachmentsSummaryPluginInterface>,
  carePlanSummary: ReturnType<CarePlanSummaryPluginInterface>,
  releaseNotesPlugin: ReturnType<ReleaseNotesPluginInterface>,
  linksAndResourcesPlugin: ReturnType<LinksAndResourcesPluginInterface>,
  completeConsultationModel: ReturnType<CompleteConsultationModelInterface>,
  completeDialogPlugin: ReturnType<CompleteDialogPluginInterface>
}

export const $ref = <R extends keyof ConfigReferences>(
  ref: R
): ConfigReferences[R] =>
  ({
    $ref: ref,
  } as any)
